// extracted by mini-css-extract-plugin
module.exports = {"number":"PlayerControl_number__3zD_D","numberinput":"PlayerControl_numberinput__1ZlsB"};